import { Component, OnInit, OnChanges, Input, ViewChild, AfterContentChecked } from '@angular/core'
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-financial-table',
  templateUrl: './financial-table.component.html',
  styleUrls: ['./financial-table.component.scss']
})
export class FinancialTableComponent implements OnInit, OnChanges, AfterContentChecked {
  @Input()
  isFullFactSheet;
  @Input() data: any
  @Input() printPage: Boolean = false
  header: Array<String> = []
  headerShow = []

  financialDataTableOptions: DataTables.Settings = {};
  financialDataTableOptionsConfig: DataTables.Settings = {};
  initTableFirstTime = false
  dataList = []
  sectionDataList = []
  lastFinance
  checkIFF
  checkSector
  information

  headerLength = 3
  constructor(
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.financialDataTableOptions = {
      ordering: false,
      searching: false,
      autoWidth: false,
      paging: false,
      info: false,
      scrollX: false,
      destroy: true,
      scrollCollapse: true,
      scrollY: '500px'
    }
    this.financialDataTableOptionsConfig = {
      ordering: false,
      searching: false,
      autoWidth: false,
      paging: false,
      info: false
    }
  }

  ngAfterContentChecked() {
    let x = document.getElementsByClassName('dataTables_scrollBody');
    if (x[0]) {
      if (x[0].scrollHeight > x[0].clientHeight) document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("scrollHeadInner");
      else document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("noScrollHeadInner");
    }
  }

  ngOnChanges() {
    if (this.data) {
      this.dataList = this.data['data']
      const header = this.data['header']
      const quarter = this.data['quarter']
      if ((!this.initTableFirstTime && this.printPage) || !this.printPage) {
        this.header = this.getHeader(header, quarter);
      }
      this.headerShow = []
      this.headerShow.push(...this.header, ...this.header)
      const lastFin = []
      lastFin.push(this.header[this.header.length - 1])
      lastFin.map(lastF => {
        let quarterM
        switch (lastF.quarterMonths) {
          case '3M ':
            quarterM = 'Q1/'
            break
          case '6M ':
            quarterM = 'Q2/'
            break
          case '9M ':
            quarterM = 'Q3/'
            break
          case '':
            quarterM = ''
            break
        }
        this.lastFinance = quarterM + lastF.year
      })
      if (!this.initTableFirstTime) this.initTableFirstTime = true
    }
  }

  getDataTableConfig() {
    if (!this.printPage) {
      return this.financialDataTableOptions
    } else {
      return this.financialDataTableOptionsConfig
    }
  }

  getHeader(header, quarter): String[] {
    const prepareHeader = (year, q) => {
      return { year: year, quarterMonths: this.getQuaterMonths(q) }
    }
    const headerTemp = header.splice(0, 3).map(x => prepareHeader(x, 4))
    if (quarter !== 4) {
      headerTemp.push(prepareHeader(header[header.length - 1], quarter))
    }
    this.headerLength = headerTemp.length
    return headerTemp
  }

  isAboveAsset(sectionHeader: String) {
    return sectionHeader === 'Asset' ? true : false
  }

  getQuaterMonths(quater: Number) {
    switch (quater) {
      case 1: {
        return '3M '
      }
      case 2: {
        return '6M '
      }
      case 3: {
        return '9M '
      }
      case 4: {
        return ''
      }
    }
  }

  isPositivenumber(value) {
    const num = parseFloat(value)
    return num < 0 ? 'negative' : 'positive'
  }

  displayAsOfDate(unit: String): Boolean {
    switch (unit) {
      case 'Date':
        return true
      default:
        return false
    }
  }

  getNotice(notice: String) {
    return notice !== null ? 'Notice' : ''
  }

  get ws_data_toExcel() {
    const ws_data = []
    ws_data.push([
      'No.',
      'Item (unit)',
      'Information',
      '',
      '',
      '',
      'Growth and differentiate',
      '',
      '',
      '',
      'Alert'
    ])

    ws_data.push([
      '',
      '',
      ...this.headerShow.map(headerObj => {
        const header = headerObj.quarterMonths + headerObj.year
        return header
      }),
    ])

    let index_number = 1

    this.dataList.forEach(sectionData => {
      if (this.isAboveAsset(sectionData['type'])) {
        ws_data.push(['Financial position statement'])
      }
      ws_data.push([sectionData['type'], '','','','','', sectionData['changeType']])
      sectionData['data'].map(rowData => {
        const list = []
        list.push(index_number.toString())
        list.push(rowData.type)
        rowData.finYear.map(financialYear => {
          const value = financialYear
          let num
          if (value !== null && !isNaN(value)) {
            num = value
          } else if (value !== null && isNaN(value)) {
            num = this.datePipe.transform(value, 'd MMM yyyy')
          } else {
            num = null
          }
          list.push(num)
        })

        rowData.finYOY.map(financialYoy => {
          const value = financialYoy
          let num
          if (value !== null && !isNaN(value)) {
            num = value
          } else if (value !== null && isNaN(value)) {
            num = this.datePipe.transform(value, 'd MMM yyyy')
          } else {
            num = null
          }
          list.push(num)
        })
        list.push(rowData.notice)
        ws_data.push(list)
        ++index_number
      })
    })
    return ws_data
  }

  getTextAlertColorLevel(rowData) {
    if (rowData.noticeLevel === 'Negative') {
      return 'red-alert'
    }
    return 'black-alert'
  }
  getProcessWord(checkiff, checksector) {
    checkiff === 'Y' || checksector === 33
      ? (this.information = 'อยู่ระหว่างดำเนินการ')
      : (this.information = 'No information found')
  }

  get getAllColumnCount(): Number {
    return 3 + this.headerLength * 2
  }

  checkLastPeriod(item, list) {
    let className;
    if (item === list.length - 1) className = "black-border-right";
    else className = "normal-border-right";
    if (!this.printPage) className += " fix-width-data";
    return className;
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/financial-table/financial-table.component.ts